import { render } from "./ExpensePage.vue?vue&type=template&id=4e6abb71&scoped=true"
import script from "./ExpensePage.vue?vue&type=script&lang=js"
export * from "./ExpensePage.vue?vue&type=script&lang=js"

import "./ExpensePage.vue?vue&type=style&index=0&id=4e6abb71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6abb71"]])

export default __exports__